//项目添加、编辑所需方法
import $http from '@/resource';

const $api = {};

/**
 * 项目录入
 *
 * @param {number} formData 表单
 *
 * @date 2018-10-18 09:20
 *
 * @returns {Promise<any>}
 */

$api.addCarrier = (formData)=>{
    const url = 'carrier';
    const promise = new Promise((resolve)=>{
        $http.post(url, formData).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
}

/**
 * 编辑项目
 *
 * @param {number} formData 表单
 *
 * @date 2018-10-18 09:20
 *
 * @returns {Promise<any>}
 */

$api.editCarrier = (formData)=>{
    const url = `carrier`;
    const promise = new Promise((resolve)=>{
        $http.put(url, formData).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
}

/**
 * 获取编辑的项目详情数据
 *
 * @param {string} itemId 项目id
 *
 * @date 2018-10-9 10:01:36
 *
 * @returns {Promise<any>}
 */
$api.getEditCarrierDetail = (itemId) => {
    const url = `carrier?id=${itemId}`;
    const promise = new Promise((resolve)=>{
        $http.get(url).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取载体地铁站
 *
 * @param {string} district 市级地区id
 *
 * @date 2018-10-9 10:01:36
 *
 * @returns {Promise<any>}
 */
$api.getMetroData = (district) => {
    const url = `metro-data?district=${district}`;
    const promise = new Promise((resolve)=>{
        $http.get(url).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/carrier/input.js